// Staff feature flags (CMT-15). The flag itself lives on the staff user's own
// `admins/{uid}` doc as `features: { <key>: true }` — key absent = disabled —
// and is read once at sign-in / session restore into authReducer.features.
// The portal never writes it (Firestore rules deny).
//
// This registry only drives the nav badge (the route itself lives in
// constants/routes.js); the backend enforces access (the statistics endpoint
// answers 404 when the flag is off).
//
// stage: 'alpha' | 'beta' — rendered as a badge next to the nav label.
const features = {
  reports: { stage: 'alpha' },
};

// Normalises whatever the admins doc holds into a plain { key: true } map.
export const normalizeFeatures = (raw) => {
  if (!raw || typeof raw !== 'object') return {};
  return Object.keys(raw).reduce((acc, key) => {
    if (raw[key] === true) acc[key] = true;
    return acc;
  }, {});
};

export const isFeatureEnabled = (featuresState, key) =>
  Boolean(featuresState && featuresState[key] === true);

export default features;
